import { all, call, fork, put, take, select } from 'redux-saga/effects';
import { logDmbErrorLocation } from '../utils/error';
import { requestHarvestSeasons, RequestHarvestSeasonParams} from '../requesters/harvestRequester';
import { HarvestAction, receiveHarvestMetadata } from '../actions/harvestActions';
import { CropAction, receiveCustomCropNominalWeights } from '../actions/cropActions';
import { OL_HARVEST } from '../constants/featureFlags';

/**
 * Return an array of all harvest season tags
 * @param {Array} harvestSeasons
 * @return {Array}
 */
function getHarvestSeasonList(harvestSeasons) {
  return harvestSeasons.map((season) => ({ season: season.seasonTag }));
}

/**
 * Calls the requester to get harvest seasons
 * @param {String} fieldUUID
 * @param {Number} userId
 * @return {Array}
 */
export function* getHarvestSeasons(fieldUUID: string, userId: number) {
  try {
    const state = yield select();
    const harvestYieldsParams: RequestHarvestSeasonParams = {
      fieldUUID,
      userId,
      useOl: (state.feature.userConfigFeatures[OL_HARVEST] || {}).value,
    }

    const { postHarvestYields } = yield call(requestHarvestSeasons, harvestYieldsParams );

    if (postHarvestYields && postHarvestYields.length) {
      yield put(receiveHarvestMetadata(postHarvestYields));
      return getHarvestSeasonList(postHarvestYields);
    }
  } catch (error) {
    logDmbErrorLocation(error, 'harvest saga - getHarvestSeasons');
  }

  yield put(receiveHarvestMetadata([]));
  return null;
}

/**
 * Wait until harvest and crops have their respective receive actions dispatched.
 * Use the data from each of these actions in the action dispatched
 * for receive harvest metadata.
 * @return {void}
 */
export function* receiveHarvestMetadataWatcher() {
  while (true) {
    const [{ metadata }] = yield all([
      take(HarvestAction.ReceiveHarvestMetadata),
      take(CropAction.ReceiveCropList),
    ]);
    yield put(receiveCustomCropNominalWeights(metadata));
  }
}

/**
 * Uses fork to start multiple watchers in parallel
 * @return {void}
 */
export default function* rootSaga() {
  yield fork(receiveHarvestMetadataWatcher);
}
